import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const ARR_IMAGE =
    "https://customer-assets.emergentagent.com/job_music-tech-hub-1/artifacts/kv1pnrsg_8a337e8142145d98801ea4a5700d60fb.jpg";

export const FeaturedArtist = () => {
    return (
        <section
            className="relative py-28 lg:py-36 overflow-hidden"
            data-testid="featured-artist-section"
        >
            <div className="absolute -top-32 left-1/3 w-[500px] h-[500px] rounded-full bg-[#791EE2] opacity-15 blur-[140px] pointer-events-none" />
            <div className="absolute -bottom-32 right-1/4 w-[400px] h-[400px] rounded-full bg-[#F54815] opacity-10 blur-[140px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: "easeOut" }}
                        className="lg:col-span-5 relative"
                    >
                        <div className="relative aspect-[4/5] rounded-[32px] overflow-hidden border border-white/10">
                            <img
                                src={ARR_IMAGE}
                                alt="A. R. Rahman"
                                className="w-full h-full object-cover"
                                data-testid="featured-artist-image"
                            />
                            {/* Gradient overlay for premium feel */}
                            <div className="absolute inset-0 bg-gradient-to-t from-[#030023] via-[#030023]/30 to-transparent pointer-events-none" />

                            {/* Floating badge */}
                            <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
                                <div>
                                    <div className="font-heading text-2xl md:text-3xl font-bold text-white tracking-tight">
                                        A. R. Rahman
                                    </div>
                                    <div className="text-sm text-white/70 mt-1">
                                        Founder · Composer · Visionary
                                    </div>
                                </div>
                                <div className="flex items-end h-8 gap-1">
                                    {[10, 18, 12, 22, 14].map((h, i) => (
                                        <span
                                            key={i}
                                            className="w-[3px] bg-[#F54815] rounded-sm eq-bar"
                                            style={{
                                                height: `${h}px`,
                                                animationDelay: `${i * 0.15}s`,
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Decorative glow border */}
                        <div className="absolute inset-0 rounded-[32px] ring-1 ring-[#791EE2]/30 pointer-events-none" />
                    </motion.div>

                    {/* Quote */}
                    <motion.div
                        initial={{ opacity: 0, x: 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: "easeOut", delay: 0.15 }}
                        className="lg:col-span-7"
                    >
                        <p className="text-sm uppercase tracking-[0.3em] text-[#F54815] mb-6 font-medium">
                            A vision from our founder
                        </p>

                        <Quote
                            className="text-[#791EE2] mb-6"
                            size={48}
                            strokeWidth={1.5}
                        />

                        <blockquote
                            className="font-heading text-3xl sm:text-4xl lg:text-5xl xl:text-[56px] font-bold tracking-tight leading-[1.1] text-white mb-10"
                            data-testid="featured-quote"
                        >
                            "Elevate{" "}
                            <span className="gradient-text">world-class talent</span>{" "}
                            to the{" "}
                            <span className="text-[#791EE2]">global stage</span>."
                        </blockquote>

                        <div className="h-px w-24 bg-gradient-to-r from-[#791EE2] to-[#F54815] mb-8" />

                        <p className="text-lg text-white/65 max-w-xl font-body leading-relaxed">
                            Backed by one of the most decorated voices in music
                            history, Maajja was built to give every independent
                            artist the same scale, reach and respect once
                            reserved for legends.
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
